module.exports = __webpack_public_path__ + "static/media/icon-trash.471d2974.svg";


//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/images/icon-trash.svg
// module id = 42
// module chunks = 0